import { useState, useCallback, useEffect, useLayoutEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { AppDispatch, RootState } from '@reducers/index';
import { Countries2DigitCode } from '@models/commonModel';
import { gameProviderTypes } from '@configs/layout';
import ReactFlagsSelect from 'react-flags-select';
import AppInfoBox from '@components/template/keyword/suggestion/appInfoBox';
import ResultKeywordsBox from '@components/template/keyword/suggestion/resultKeywordsBox';
import RegisteredBox from '@components/template/keyword/suggestion/registeredBox';
import { fetchKeywordGroupList } from '@reducers/keywordSlice';
import { fetchRegisteredData } from '@reducers/keyword/thunk/suggestionThunk';

type Props = {};
const Suggestion = (props: Props) => {
  const dispatch = useDispatch<AppDispatch>();
  // useEffectLayoutEffect로 groupList 가져오기
  useLayoutEffect(() => {
    dispatch(fetchKeywordGroupList({ email: 'SS' }));
    dispatch(fetchRegisteredData({ email: 'SS' }));
  }, []);
  return (
    <>
      <AppInfoBox />
      <div className="research-wrap">
        <ResultKeywordsBox />
        <RegisteredBox />
      </div>
    </>
  );
};

export default Suggestion;
